import { ReactComponent as RightArrow } from 'assets/icons/chevron-right-icon.svg'
import styled from 'styled-components'
import { breakpoints, colors, fontWeight } from 'theme'

export const ChilipiperMessageSection = styled.div<{ width?: string }>(
  {
    backgroundColor: 'rgba(27, 81, 164, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    padding: '12px',
    borderRadius: '4px',
    fontWeight: fontWeight.semibold,
  },
  ({ width }) =>
    width && {
      width: width,
    },
)

export const ChilipiperToastMessage = styled.div({
  color: colors.primary.medium,
  fontSize: '13px',
})

export const ChilipiperToastLink = styled.button({
  display: 'flex',
  alignItems: 'center',
  color: colors.blue[700],
  width: 'max-content',
  fontWeight: fontWeight.semibold,
  fontSize: '12px',
})

export const ChilipiperEmbed = styled.iframe({
  width: '340px',
  height: '500px',
  [`@media ${breakpoints.lg}`]: {
    width: '560px',
    height: '700px',
  },
  [`@media ${breakpoints.xl}`]: {
    width: '560px',
    height: '700px',
  },
})

export const ChevronRightIcon = styled(RightArrow)({
  margin: '.2rem 0',
})
